const CalendarLegend = () => (
  <>
    <div className='calendar-legend'>
      <span className='calendar-grid__day calendar-grid__day--free calendar-legend__sample'>7</span>
      — даты, доступные для заезда
    </div>
    <div className='calendar-legend calendar-legend--note'>
      * Наличие свободных номеров проверяет отдел бронирования после получения заявки.
    </div>
  </>
);

export default CalendarLegend;
